export { LegendImages } from './LegendImages.component';
